// useSelectTableByNumber.ts
import { statusTableData, paymentTableData } from "../../local-data/localData"
import type { SelectTable, Table } from "../../models/table"

import { systemTablesApi } from "./system-tables.api"
import { accountsApi } from "./accounts.api"
import { documentsSettingsApi } from "./documents-settings.api"
import { useCallback } from "react"
import { Account } from "../../models/account"
import { DocumentSettings } from "../../models/document-settings"


export function useSelectTableByNumber() {
  // always create lazy hooks unconditionally
  const [triggerSys]   = systemTablesApi.useLazyGetSystemTableOptionsQuery()
  const [triggerAccts] = accountsApi.useLazyGetAccountsByTypeQuery()
  const [triggerDocs]  = documentsSettingsApi.useLazyGetDocumentsSettingsQuery()

  // our unified function
  const getData = useCallback(
    async (tableNumber: number): Promise<SelectTable[]> => {
      // local tables
      if (tableNumber === 19) return statusTableData
      if (tableNumber === 20) return paymentTableData

      // system tables 1..6
      if (tableNumber >= 1 && tableNumber <= 6) {
        return convertSystemTableToSelectTable(await triggerSys(tableNumber, true).unwrap());
      }

      // accounts tables (reuse the same endpoint with different arg)
      if (tableNumber === 12) return convertAccountToSelectTable(await triggerAccts("הכנסה", true).unwrap());
      if (tableNumber === 13) return convertAccountToSelectTable(await triggerAccts("הוצאה", true).unwrap());
      if (tableNumber === 14) return convertAccountToSelectTable(await triggerAccts("בנק", true).unwrap());
      if (tableNumber === 15) return convertAccountToSelectTable(await triggerAccts("קופה", true).unwrap());

      // documents table
      if (tableNumber === 18) {
        return convertDocumentsSettingsToSelectTable(await triggerDocs(undefined, true).unwrap());
      }

      return []
    },
    [triggerSys, triggerAccts, triggerDocs]
  )

  return [getData] as const
}

function convertSystemTableToSelectTable(table: Table[] ): SelectTable[]{
    return table.map((option) => ({
        index: option.index,
        name: option.name
    }))
}

function convertAccountToSelectTable(accounts: Account[] ): SelectTable[]{
    return accounts.map((account) => ({
        index: account.card_number,
        name: account.account_name
    }))
}

function convertDocumentsSettingsToSelectTable(docsSettings: DocumentSettings[] ): SelectTable[]{
    return docsSettings.map((settings) => ({
        index: settings.id,
        name: settings.name
    }))
}